import { render, staticRenderFns } from "./InquiryDetailPlan.vue?vue&type=template&id=34ed544a&scoped=true"
import script from "./InquiryDetailPlan.vue?vue&type=script&lang=js"
export * from "./InquiryDetailPlan.vue?vue&type=script&lang=js"
import style0 from "./InquiryDetailPlan.vue?vue&type=style&index=0&id=34ed544a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed544a",
  null
  
)

export default component.exports